import { Alert, Col, DatePicker, Form, InputNumber, List, message, Row, Select, Table } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
// import { getDocumentDetail } from 'services/session';
import { getDocumentDetail, requestApproval, updateApproval } from 'services/session';
import { getVdsOfUser } from 'services/users';
import { RequestInfo, UserSearchInput } from './components';
import { getErrorFields } from '../utils';

function DesktopUpdate({ readOnly, form, id, onClose }) {
  const [user, setUser] = React.useState();
  const [desktops, setDesktops] = useState([]);
  const [userName, setUserName] = React.useState('');
  const [after, setAfter] = React.useState('');
  useEffect(() => {
    if (!id) {
      form.resetFields();
      setDesktops([]);
      setUser(undefined);

      const applicant = localStorage.getItem('userId');
      form.setFieldsValue({
        applicant,
        type: 'approval.types.change-spec-vd',
      });
      return;
    }

    getDocumentDetail(id).then((data) => {
      const contents = data?.contents?.[0];

      const after1 = {
        id: contents.id,
        after: {
          vCpu: contents.after?.vCpu,
          memory: contents.after?.memory,
          disk: contents.after?.disk,
        },
      };
      setAfter(after1);

      let approveDate = data?.approveDate;

      if (approveDate !== null) {
        approveDate = moment(approveDate);
      }
      form.setFieldsValue({
        ...data,
        contents,
        approveDate,
        applyDate: moment(data.applyDate).format('YYYY-MM-DD HH:mm:ss'),
      });

      setUser(data?.user);
      setUserName(data?.userName);
    });
  }, [id]);

  useEffect(() => {
    if (user) {
      getVdsOfUser(user, id).then((data) => {
        const desktop = data.data;
        let i = 0;
        const contents = desktop.map((d, index) => {
          const before = {
            id: d.id,
            name: d.vdName,
            locale: 'ko',
            before: {
              vCpu: d.cpu,
              memory: d.memory,
              disk: d.disk,
            },
            after: {},
          };
          if (after?.id === d.id) {
            i = index;
            return { ...before, after: after.after };
          }
          return before;
        });
        setDesktops(contents);

        form.setFieldsValue({ contents: contents[i] });
      });
    }
  }, [user]);

  const ChangeSpec = ({ readOnly1, value, onChange }) => {
    const [dataSource, setDataSource] = useState([]);
    const [data, setData] = useState(value);
    useEffect(() => {
      setData(value);
      setDataSource([
        {
          item: 'CPU',
          before: value?.before?.vCpu,
          after: value?.after?.vCpu,
        },
        {
          item: 'Memory',
          before: value?.before?.memory,
          after: value?.after?.memory,
        },
        {
          item: 'Disk',
          before: value?.before?.disk,
          after: value?.after?.disk,
        },
      ]);
    }, [value]);

    return (
      <Table
        size="small"
        rowKey="key"
        pagination={false}
        dataSource={dataSource}
        columns={[
          {
            title: '구분',
            dataIndex: 'item',
            width: '20%',
          },
          {
            title: '변경 전',
            dataIndex: 'before',
            width: '40%',
            render: (text, record) => {
              let unit = '';
              switch (record.item) {
                case 'CPU':
                  unit = 'Core';
                  break;
                case 'Memory':
                  unit = 'GB';
                  break;
                case 'Disk':
                  unit = 'GB';
                  break;
                default:
                  unit = '';
              }
              return (
                <span>
                  {text}
                  {unit}
                </span>
              );
            },
          },
          {
            title: '변경 후',
            dataIndex: 'after',
            width: '40%',
            render: (text, record) => {
              let unit = '';
              switch (record.item) {
                case 'CPU':
                  unit = 'Core';
                  break;
                case 'Memory':
                  unit = 'GB';
                  break;
                case 'Disk':
                  unit = 'GB';
                  break;
                default:
                  unit = '';
              }
              switch (record.item) {
                case 'CPU':
                  return (
                    <Form.Item name={['contents', 'after', 'vCpu']}>
                      <InputNumber
                        value={record.after}
                        addonAfter={unit}
                        style={{ width: 120 }}
                        disabled={readOnly1}
                        min={0}
                        onChange={
                          data &&
                          ((val) => {
                            data.after.vCpu = val;
                            onChange(data);
                          })
                        }
                      />
                    </Form.Item>
                  );
                case 'Memory':
                  return (
                    <Form.Item name={['contents', 'after', 'memory']}>
                      <InputNumber
                        value={record.after}
                        addonAfter={unit}
                        style={{ width: 120 }}
                        disabled={readOnly1}
                        min={0}
                        onChange={
                          data &&
                          ((val) => {
                            data.after.memory = val;
                            onChange(data);
                          })
                        }
                      />
                    </Form.Item>
                  );
                case 'Disk':
                  return (
                    <Form.Item name={['contents', 'after', 'disk']}>
                      <InputNumber
                        value={record.after}
                        addonAfter={unit}
                        style={{ width: 120 }}
                        disabled={readOnly1}
                        min={0}
                        onChange={
                          data &&
                          ((val) => {
                            data.after.disk = val;
                            onChange(data);
                          })
                        }
                      />
                    </Form.Item>
                  );
                default:
                  return 0;
              }
            },
          },
        ]}
      />
    );
  };
  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 19 }}
      onFinish={async ({ contents, approveDate, ...fields }) => {
        const payload = {
          ...fields,
          contents: JSON.stringify([contents]),
          approveDate: approveDate?.format('YYYY-MM-DD HH:mm:ss'),
        };
        try {
          const result = id ? await updateApproval(id, payload) : await requestApproval(payload);
          if (result.data.status === 'error') {
            const errors = getErrorFields(result.data.invalidParams);
            form.setFields(errors);
            return;
          }
          form.resetFields();
          onClose();
        } catch (e) {
          message.error(e);
        }
      }}
    >
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Alert
            showIcon
            type="warning"
            message={
              <List
                size="small"
                split={false}
                style={{ marginLeft: 16 }}
                dataSource={[
                  'CPU/Memory/Disk 증설 작업 시 VD 리부팅이 필요합니다. 설정된 작업 시간 전에 작업중이던 모든 문서들을 저장해주시기 바랍니다.',
                  '증설 작업 시작 이후 30분 이후까지 접속이 불가합니다. 이 점 참고하시어 작업 희망 일시를 선정하시기 바랍니다.',
                  'VD 사양 변경 신청은 중복 신청이 불가능하오니 승인된 작업 완료 후에 다시 신청해주시기 바랍니다.',
                ]}
                renderItem={(item) => <List.Item style={{ padding: 0 }}>{item}</List.Item>}
              />
            }
          />
        </Col>
        <Col span={24}>
          <RequestInfo readOnly={readOnly} />
          <Form.Item label="신청 종류" name="type" required>
            VD 사양 변경
          </Form.Item>
          <Form.Item
            label="사용자(ID)"
            name="user"
            rules={[{ required: true, message: '필수 입력 항목 입니다.' }]}
          >
            <UserSearchInput
              readOnly1={readOnly}
              onSuccess={async (uid) => {
                // 처리
                setUser(uid);
              }}
              userName={userName}
            />
          </Form.Item>

          <Form.Item
            label="VD 사양 변경"
            name={['contents', 'id']}
            rules={[{ required: true, message: '필수 입력 항목 입니다.' }]}
          >
            <Select
              placeholder="사용자를 선택하면 Desktop 목록이 표시됩니다."
              style={{ width: 'auto' }}
              disabled={readOnly}
              onSelect={(val) => {
                form.setFieldsValue({
                  contents: desktops.find((d) => d.id === val),
                });
              }}
              options={desktops?.map((desktop) => ({
                label: desktop.name,
                value: desktop.id,
              }))}
            />
          </Form.Item>
          <Form.Item
            label={null}
            wrapperCol={{ offset: 5 }}
            name="contents"
            rules={[{ required: true, message: '필수 입력 항목 입니다.' }]}
          >
            <ChangeSpec readOnly1={readOnly} />
          </Form.Item>
          <Form.Item
            label="작업 희망 일시"
            name="approveDate"
            extra="작업 희망 일시를 설정하지 않거나 이미 경과된 경우 승인 시점에 처리됩니다."
            rules={[
              () => ({
                validator(_, value) {
                  if (value > moment() || !value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('현재보다 이전 시간은 설정할 수 없습니다.'));
                },
              }),
            ]}
          >
            <DatePicker
              showTime={{
                defaultValue: moment('00:00', 'HH:mm'),
                format: 'HH:mm',
              }}
              inputReadOnly={1}
              disabled={readOnly}
              placeholder=""
              disabledDate={(current) => current && current < moment().add(-1, 'day')}
              showNow={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default DesktopUpdate;
